/* =========================================
   Header blur on scroll
========================================= */
(() => {
  const header = document.querySelector('.header-block');
  if (!header) return;

  const THRESHOLD = 150;
  const apply = () => {
    const y = window.scrollY || 0;
    if (y > THRESHOLD) header.classList.add('header-blur');
    else header.classList.remove('header-blur');
  };

  apply();
  window.addEventListener('scroll', apply, { passive: true });
})();

/* =========================================
   Mega Menu hover – aktivna sekcija (desktop)
========================================= */
(() => {
  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
  const panel        = document.querySelector('.nav-mega-menu-block');
  const primaryLinks = document.querySelectorAll('.nav-mega-menu-block__primary-link');
  if (!panel || !primaryLinks.length) return;

  const allGroups   = document.querySelectorAll('.nav-mega-menu-block__group');
  const allColsWrap = document.querySelectorAll('.nav-mega-menu-block__columns-wrapper');
  const allFeatured = document.querySelectorAll('.nav-mega-menu-block__featured');

  function runReenter() {
    document.querySelectorAll('.mm-reenter').forEach(el => el.classList.remove('mm-reenter'));
    const actCols   = document.querySelectorAll('.nav-mega-menu-block__columns-wrapper.active');
    const actGroups = document.querySelectorAll('.nav-mega-menu-block__group.active');
    actCols.forEach(el => void el.offsetHeight);
    actGroups.forEach(el => void el.offsetHeight);
    actCols.forEach(el => el.classList.add('mm-reenter'));
    actGroups.forEach(el => el.classList.add('mm-reenter'));
  }

  const showFor = (menu, isThird) => {
    if (isMobile()) return;
    allGroups.forEach(el => el.classList.remove('active'));
    allColsWrap.forEach(el => el.classList.remove('active'));
    allFeatured.forEach(el => el.classList.remove('active'));

    const cols   = document.querySelectorAll(`.nav-mega-menu-block__columns-wrapper[data-menu="${menu}"]`);
    const groups = document.querySelectorAll(`.nav-mega-menu-block__group[data-menu="${menu}"]`);
    const feats  = document.querySelectorAll(`.nav-mega-menu-block__featured[data-menu="${menu}"]`);

    let anyShown = false;
    if (cols.length)   { cols.forEach(c => c.classList.add('active'));   anyShown = true; }
    if (groups.length) { groups.forEach(g => g.classList.add('active')); anyShown = true; }
    if (feats.length)  { feats.forEach(f => f.classList.add('active'));  anyShown = true; }

    if (!anyShown) {
      allColsWrap[0]?.classList.add('active');
      allGroups[0]?.classList.add('active');
      allGroups[1]?.classList.add('active');
      allFeatured[0]?.classList.add('active');
    }

    if (isThird) {
      panel.classList.add('mm-primary-3');
    } else {
      panel.classList.remove('mm-primary-3');
    }

    runReenter();
  };

  panel.addEventListener('mm:reveal', runReenter);

  primaryLinks.forEach((link, idx) => {
    link.addEventListener('mouseenter', () => {
      if (isMobile()) return;
      const menu = link.getAttribute('data-menu');
      if (menu) showFor(menu, idx === 2);
    });
  });
})();

/* =========================================
   Header dropdown (Shop) – hover (desktop)
========================================= */
(() => {
  const isMobile     = () => window.matchMedia('(max-width: 989px)').matches;
  const shopLink = document.querySelector('.header-block__nav-link.has-dropdown[data-name="shop"], .header-block__nav-link.has-dropdown[data-name="shop-d"]');
  const shopName = shopLink?.getAttribute('data-name');
  const dropdownMenu = shopName ? document.querySelector(`.nav-dropdowns .dropdown-menu[data-name="${shopName}"]`) : null;  const header       = document.querySelector('.header-block');
  if (!shopLink || !dropdownMenu || !header) return;
  if (isMobile()) return;

  let dropdownTimeout;

  function showDropdown() {
    clearTimeout(dropdownTimeout);
    dropdownMenu.classList.add('show', 'fade-in');
    dropdownMenu.classList.remove('fade-out');
    dropdownMenu.style.display    = 'block';
    dropdownMenu.style.opacity    = '1';
    dropdownMenu.style.visibility = 'visible';
  }

  function hideDropdown() {
    dropdownMenu.classList.remove('fade-in');
    dropdownMenu.classList.add('fade-out');
    dropdownMenu.style.opacity    = '0';
    dropdownMenu.style.visibility = 'hidden';
    dropdownTimeout = setTimeout(() => {
      dropdownMenu.classList.remove('show');
      dropdownMenu.style.display = 'none';
    }, 200);
  }

  shopLink.addEventListener('mouseenter', showDropdown);
  shopLink.addEventListener('mouseleave', () => { dropdownTimeout = setTimeout(hideDropdown, 150); });
  dropdownMenu.addEventListener('mouseenter', showDropdown);
  dropdownMenu.addEventListener('mouseleave', () => { dropdownTimeout = setTimeout(hideDropdown, 150); });

  // Submeniji
  const attachSubmenus = () => {
    dropdownMenu.querySelectorAll('.dropdown-item[data-name]').forEach(item => {
      const name    = item.getAttribute('data-name');
      const wrap    = document.querySelector(`.dropdown-sub-menu .submenu-wrap[data-type="${name}"]`);
      const submenu = wrap?.parentElement;
      if (!submenu) return;

      let submenuTimeout;

      const showSub = () => {
        clearTimeout(submenuTimeout);
        dropdownMenu.querySelectorAll('.dropdown-sub-menu').forEach(sm => {
          if (sm !== submenu) {
            sm.style.display = 'none';
            sm.style.opacity = '0';
            sm.style.visibility = 'hidden';
            sm.style.pointerEvents = 'none';
            sm.style.animation = 'none';
          }
        });
        submenu.style.display = 'block';
        submenu.style.opacity = '1';
        submenu.style.visibility = 'visible';
        submenu.style.pointerEvents = 'auto';
        submenu.style.animation = 'fadeInDown .3s ease forwards';
      };

      const hideSub = () => {
        submenuTimeout = setTimeout(() => {
          if (!item.matches(':hover') && !submenu.matches(':hover')) {
            submenu.style.animation = 'fadeOutUp .3s ease forwards';
            setTimeout(() => {
              submenu.style.display = 'none';
              submenu.style.opacity = '0';
              submenu.style.visibility = 'hidden';
              submenu.style.pointerEvents = 'none';
            }, 200);
          }
        }, 200);
      };

      item.addEventListener('mouseenter', showSub);
      item.addEventListener('mouseleave', hideSub);
      submenu.addEventListener('mouseenter', showSub);
      submenu.addEventListener('mouseleave', hideSub);
    });
  };

  attachSubmenus();
})();


/* =========================================
   Mega Menu (desktop) + Mobile drawer (≤989px)
   — ujedinjen handler
========================================= */
(() => {
  const openBtn  = document.getElementById('open-megamenu');
  const closeBtn = document.getElementById('close-megamenu');
  const panel    = document.querySelector('.nav-mega-menu-block');
  if (!openBtn) return;

  if (openBtn.dataset.mmUnifiedWired === '1') return;
  openBtn.dataset.mmUnifiedWired = '1';

  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
  const root = document.documentElement;

  /* helper za sakrivanje/prikaz burgere/X */
  function setBurgerVisible(isVisible) {
    if (!openBtn) return;
    if (isVisible) {
      openBtn.style.opacity = '';
      openBtn.style.pointerEvents = '';
    } else {
      openBtn.style.opacity = '0';
      openBtn.style.pointerEvents = 'none';
    }
  }

  /* ---------- MOBILE DRAWER ---------- */
  const mobile    = document.getElementById('mobile-menu');
  const mClose    = document.getElementById('mobile-menu-close');
  const mOverlay  = mobile?.querySelector('.mobile-menu__overlay');
  const mBack     = mobile?.querySelector('.mobile-menu__back');
  const mBackbar  = mobile?.querySelector('.mobile-menu__backbar');
  const mTitle    = mobile?.querySelector('.mobile-menu__bartitle');
  const viewsWrap = mobile?.querySelector('.mobile-menu__views');
  const mPanel    = mobile?.querySelector('.mobile-menu__panel');
  const mBody     = mobile?.querySelector('.mobile-menu__body');

  const focusableSel = 'a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])';
  let trapOn = false;
  let stack = ['root'];

  /* ---- Drill helpers ---- */
  const getView = (id) => viewsWrap?.querySelector(`.mobile-menu__view[data-view-id="${id}"]`);

  const setTitle = (id) => {
    // OVDE JE JEDINA IZMJENA: umesto naziva view-a, uvek pišemo "Back" kad nismo na rootu
    if (mTitle) {
      mTitle.textContent = (id === 'root') ? '' : 'Back';
    }
    if (mBackbar) mBackbar.hidden = (id === 'root');

    // ovde: ako NISMO na root → sakrij X; ako smo na root → prikaži X
    setBurgerVisible(id === 'root');
  };

  const showOnly = (id) => {
    if (!viewsWrap) return;
    viewsWrap.querySelectorAll('.mobile-menu__view').forEach(v => {
      const isTarget = v.dataset.viewId === id;
      v.toggleAttribute('hidden', !isTarget);
      v.classList.remove('mm-slide-left-in','mm-slide-left-out','mm-slide-right-in','mm-slide-right-out');
    });
    setTitle(id);
  };

  const animateSwap = ({ fromId, toId, outClass, inClass }) => {
    const from = getView(fromId);
    const to   = getView(toId);
    if (!from || !to || from === to) return;

    to.removeAttribute('hidden');
    to.classList.remove('mm-slide-left-in','mm-slide-left-out','mm-slide-right-in','mm-slide-right-out');

    from.classList.remove('mm-slide-left-in','mm-slide-right-in');
    from.classList.add(outClass);
    to.classList.add(inClass);

    const onDone = () => {
      from.setAttribute('hidden','');
      from.classList.remove(outClass);
      to.classList.remove(inClass);
      from.removeEventListener('animationend', onDone);
      setTitle(toId); // ovde će se uključiti/isključiti burger
    };
    from.addEventListener('animationend', onDone, { once: true });
  };

  /* ---- Mobile open/close ---- */
  const mobileOpen = () => {
    if (!mobile) return;
    showOnly('root');       // ovo će i prikazati X
    stack = ['root'];
    mobile.classList.remove('hidden');
    mobile.setAttribute('aria-hidden','false');
    root.classList.add('mm-open');

    if (mPanel) {
      mPanel.classList.remove('slide-down-to-bottom');
      mPanel.classList.add('slide-up-from-bottom');
      const onEndOpen = (e) => {
        if (e.target !== mPanel) return;
        mPanel.classList.remove('slide-up-from-bottom');
        mPanel.removeEventListener('animationend', onEndOpen);
      };
      mPanel.addEventListener('animationend', onEndOpen);
    }

    openBtn.classList.add('is-active');
    openBtn.setAttribute('aria-expanded','true');
    openBtn.dataset.state = 'open';

    (mClose || mobile.querySelector(focusableSel))?.focus?.();
    trapOn = true;
  };

  const mobileClose = () => {
    if (!mobile) return;

    if (mPanel) {
      mPanel.classList.remove('slide-up-from-bottom');
      mPanel.classList.add('slide-down-to-bottom');

      const onEndClose = (e) => {
        if (e.target !== mPanel) return;
        mPanel.classList.remove('slide-down-to-bottom');
        mobile.classList.add('hidden');
        mobile.setAttribute('aria-hidden','true');
        mPanel.removeEventListener('animationend', onEndClose);
      };
      mPanel.addEventListener('animationend', onEndClose);
    } else {
      mobile.classList.add('hidden');
      mobile.setAttribute('aria-hidden','true');
    }

    root.classList.remove('mm-open');
    openBtn.classList.remove('is-active');
    openBtn.setAttribute('aria-expanded','false');
    openBtn.dataset.state = 'closed';
    trapOn = false;

    // kad zatvorimo – X opet normalno
    setBurgerVisible(true);
  };

  const mobileToggle = () => {
    if (!mobile) return;
    mobile.classList.contains('hidden') ? mobileOpen() : mobileClose();
  };

  /* ---- Drill (strelica desno) ---- */
  mobile?.addEventListener('click', (e) => {
    const chevBtn = e.target.closest('.mobile-menu__chev-btn');
    if (chevBtn) e.stopPropagation();

    const btn = e.target.closest('.mobile-menu__link--drill');
    if (!btn) return;

    e.preventDefault();
    const toId = btn.getAttribute('data-drillto');
    const ttl  = btn.getAttribute('data-title') || '';
    const toView = getView(toId);
    if (!toView) return;

    if (ttl && !toView.getAttribute('aria-label')) toView.setAttribute('aria-label', ttl);

    toView.scrollTop = 0;
    btn.classList.add('is-drilling');
    animateSwap({
      fromId: stack[stack.length - 1],
      toId,
      outClass: 'mm-slide-left-out',
      inClass:  'mm-slide-left-in'
    });
    stack.push(toId);
    setTimeout(() => btn.classList.remove('is-drilling'), 180);
  });

  /* ---- Back (levo) ---- */
  mBack && mBack.addEventListener('click', (e) => {
    e.preventDefault();
    if (stack.length <= 1) return;
    const fromId = stack.pop();
    const toId   = stack[stack.length - 1];
    if (mBody) mBody.scrollTop = 0;
    animateSwap({
      fromId,
      toId,
      outClass: 'mm-slide-right-out',
      inClass:  'mm-slide-right-in'
    });
  });

  /* Close actions */
  mClose   && mClose.addEventListener('click', (e) => { e.preventDefault(); mobileClose(); });
  mOverlay && mOverlay.addEventListener('click', (e) => { e.preventDefault(); mobileClose(); });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isMobile() && mobile?.getAttribute('aria-hidden') === 'false') mobileClose();
  });

  // Zatvori na klik linka u listi
  mobile?.addEventListener('click', (e) => {
    const a = e.target.closest('a.mobile-menu__link, a.mobile-menu__sublink, a.mobile-menu__extra-link');
    if (!a) return;
    setTimeout(mobileClose, 0);
  });

  // Focus trap
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !trapOn || mobile?.getAttribute('aria-hidden') === 'true') return;
    const nodes = mobile.querySelectorAll(focusableSel);
    const focusables = Array.from(nodes).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0];
    const last  = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Resize: izlazak iz mobile → reset + close
  window.addEventListener('resize', () => {
    if (!isMobile()) {
      showOnly('root');
      stack = ['root'];
      mobileClose();
    }
  }, { passive: true });

  /* ---------- DESKTOP (mega meni) ---------- */
  const panelEl = panel || null;

  if (panelEl) {
    if (panelEl.dataset.mmWired === '1') {
      // već ožičen
    } else {
      panelEl.dataset.mmWired = '1';
      if (!panelEl.id) panelEl.id = 'nav-mega-menu';
      openBtn.setAttribute('aria-controls', panelEl.id);
      openBtn.setAttribute('aria-expanded', 'false');
      panelEl.setAttribute('aria-hidden', 'true');

      panelEl.classList.add('hidden');
      panelEl.classList.remove('slide-up-from-bottom', 'slide-down-to-bottom', 'mm-reveal-start', 'mm-prehide');

      const isOpen = () => !panelEl.classList.contains('hidden') && !panelEl.classList.contains('slide-down-to-bottom');
      let inTransition = false;

      const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
      const setOpenOffset = (ms) => panelEl.style.setProperty('--mm-open-offset', prefersReduced ? '0ms' : `${ms}ms`);
      const isPanelAnim = (e) => e && e.target === panelEl;

      const msFromCssDurationStr = (v) => {
        if (!v) return 0;
        const s = String(v).trim();
        if (s.endsWith('ms')) return parseFloat(s);
        if (s.endsWith('s'))  return parseFloat(s) * 1000;
        return parseFloat(s) || 0;
      };
      const getPanelAnimDurationMs = () => {
        const cs = getComputedStyle(panelEl);
        const first = (cs.animationDuration || '0s').split(',')[0];
        return msFromCssDurationStr(first) || 1050;
      };
      const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
      const fallbackMs = () => Math.max(getPanelAnimDurationMs() + 260, 1350);

      function primeFirstSection() {
        const first = panelEl.querySelector('.nav-mega-menu-block__primary-link');
        if (first) first.dispatchEvent(new Event('mouseenter', { bubbles: true }));
      }
      function resetInnerAnimations() {
        panelEl.classList.remove('mm-reveal-start', 'mm-prehide');
        panelEl.querySelectorAll('.mm-reenter').forEach(el => el.classList.remove('mm-reenter'));
        panelEl.style.removeProperty('--mm-open-offset');
      }
      function openDesktopMenu() {
        if (inTransition || isOpen()) return;
        inTransition = true;

        root.classList.add('mm-open');
        panelEl.classList.add('mm-prehide');

        panelEl.classList.remove('hidden', 'slide-down-to-bottom');
        panelEl.classList.add('slide-up-from-bottom');

        openBtn.classList.add('is-active');
        openBtn.setAttribute('aria-expanded', 'true');
        openBtn.dataset.state = 'open';
        panelEl.setAttribute('aria-hidden', 'false');

        requestAnimationFrame(() => {
          const dur = getPanelAnimDurationMs();
          const offset = clamp(Math.round(dur * 0.35), 220, 600);
          setOpenOffset(offset);
          setTimeout(() => {
            panelEl.classList.add('mm-reveal-start');
            panelEl.classList.remove('mm-prehide');
            panelEl.dispatchEvent(new CustomEvent('mm:reveal'));
          }, offset);
        });

        setTimeout(primeFirstSection, 80);
        (closeBtn || panelEl.querySelector('a,button,[tabindex]:not([tabindex="-1"])'))?.focus?.();

        const onEnd = (e) => {
          if (!isPanelAnim(e)) return;
          panelEl.classList.remove('slide-up-from-bottom');
          inTransition = false;
        };
        panelEl.addEventListener('animationend', onEnd, { once: true });

        setTimeout(() => {
          if (inTransition) {
            panelEl.classList.remove('slide-up-from-bottom');
            inTransition = false;
          }
        }, fallbackMs());
      }
      function closeDesktopMenu() {
        if (inTransition || !isOpen()) return;
        inTransition = true;

        root.classList.remove('mm-open');
        openBtn.classList.remove('is-active');
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.dataset.state = 'closed';
        panelEl.setAttribute('aria-hidden', 'true');

        panelEl.classList.remove('slide-up-from-bottom');
        panelEl.classList.add('slide-down-to-bottom');

        const onEnd = (e) => {
          if (!isPanelAnim(e)) return;
          panelEl.classList.add('hidden');
          panelEl.classList.remove('slide-down-to-bottom');
          resetInnerAnimations();
          inTransition = false;
          openBtn.focus?.();
        };
        panelEl.addEventListener('animationend', onEnd, { once: true });

        setTimeout(() => {
          if (inTransition) {
            panelEl.classList.add('hidden');
            panelEl.classList.remove('slide-down-to-bottom');
            resetInnerAnimations();
            inTransition = false;
            openBtn.focus?.();
          }
        }, fallbackMs());
      }

      // desktop close
      closeBtn && closeBtn.addEventListener('click', (e) => {
        if (isMobile()) return;
        e.preventDefault();
        closeDesktopMenu();
      });

      // ESC desktop
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !isMobile() && isOpen()) closeDesktopMenu();
      });

      // burger – unified
      openBtn.addEventListener('click', (e) => {
        if (isMobile() && mobile) {
          e.preventDefault();
          mobileToggle();
          return;
        }
        e.preventDefault();
        !isOpen() ? openDesktopMenu() : closeDesktopMenu();
      });
    }
  } else {
    // bez desktop panela – burger radi samo mobile drawer
    openBtn.addEventListener('click', (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      mobileToggle();
    });
  }
})();
